
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Chip from '@/components/UI/chip/Chip.vue';

@Component({
  components: {
    Chip,
  },
})
export default class DriverByDayLookup extends Vue {
  @Prop({ type: Array || String, required: true }) public value: string | number[];
  @Prop({ type: Array, required: true }) public items: number[];
  @Prop({ type: Boolean, required: false }) public disabled: boolean;

  public chosenItems: number[] = [];
  public date = '';
  public hintText = 'There are no available drivers on this day. Try to choose another day';

  public changed(items): void {
    this.$emit('changeDrivers', items);
  }

  public toggleAll(): void {
    let newValue: number[] = [];
    if (this.value.length < this.items.length) {
      newValue = this.items;
    }
    this.$emit('changeDrivers', newValue);
  }

  public get toggleAllStatesIcon(): string {
    if (this.value.length === 0) {
      return 'mdi-checkbox-blank-outline';
    } else if (this.value.length === this.items.length) {
      return 'mdi-checkbox-marked';
    } else {
      return 'mdi-minus-box';
    }
  }

  public chipCloseClicked(value): void {
    console.log('chipCloseClicked:', value, this.disabled);

    if (this.disabled) {
      return;
    }
    if (Array.isArray(this.value)) {
      const idx = this.value.indexOf(value);
      if (idx >= 0) {
        this.value.splice(idx, 1);
      }
    }
  }

  @Watch('value', { immediate: true })
  private async valueChanged(): Promise<void> {
    if (Array.isArray(this.value)) {
      this.chosenItems = this.value;
    } else {
      this.chosenItems = this.items;
    }
  }
}
